// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1MetaDataSetMetaDataSetMetaDataResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1MetaDataSetMetaDataSetMetaDataResponse.attributeTypeMap;
    }
}
PayloadStagingV1MetaDataSetMetaDataSetMetaDataResponse.discriminator = undefined;
PayloadStagingV1MetaDataSetMetaDataSetMetaDataResponse.additionalProperties = false;
PayloadStagingV1MetaDataSetMetaDataSetMetaDataResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1MetaDataSetMetaDataSetMetaDataResponse.js.map